<div class="designBeforeFooter" *ngIf="showFooter">
</div>
<footer class="footer" id="footer" style="Position: relative;" *ngIf="showFooter">
  <div class="container clearfix">
    <div class="footer-logo">
      <a href="index.html">
        <img alt="" src="https://www.mylifewell.com/assets/images/logo/300.png">
      </a>
      <h2>My LifeWell</h2>
      <p>@ 2024 G2 Wellness Inc.</p>
      <p> All right reserved. Terms &amp; Policy </p>
    </div>
    <div class="footer-nav clearfix">
      <ul>
        <li>
          <a href="/about-us"> About Us </a>
        </li>
        <li>
          <a href="/career"> Careers </a>
        </li>
        <!-- <li>
          <a href="/partners"> Partners </a>
        </li> -->
        <li>
          <a (click)="goToUrl('https://business.mylifewell.com/')">
            B2B Solutions
          </a>
        </li>
        <li>
          <a href="/contact"> Contact Us </a>
        </li>

      </ul>
      <ul>
        <li>
          <a href="https://www.mylifewell.com/blogs/" target="_blank">
            Blogs
          </a>
        </li>
        <li>
          <a href="/terms-conditions"> Terms &amp; Conditions </a>
        </li>
        <li>
          <a href="/privacy_policy"> Privacy Policy </a>
        </li>
        <li></li>
        <li>
          <a href="/faqs"> FAQs </a>
        </li>
        <!-- <li>
          <a href="/site-map"> Site Map </a>
        </li> -->
      </ul>
    </div>
    <div class="contact-media">
      <div class="contact">
        <h2> Contact us !</h2>
        <a href="mailto:info@mylifewell.com"> Email - info@mylifewell.com </a>
        <!-- <a href="tel:18882103805"> Ph - 888-210-3805.</a> -->
      </div>
      <div class="media">
        <h2> We're social. Join us!</h2>
        <ul class="text-center">
          <li>
            <a href="https://www.facebook.com/mylifewell1" target="_blank">
              <i class="icon-fb">&nbsp;</i>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/mylifewell_" target="_blank"><i class="icon-twit">&nbsp;</i></a>
          </li>
          <li>
            <a href="https://www.instagram.com/mylifewell_/" target="_blank"><i class="icon-ins">&nbsp;</i></a>
          </li>
          <li>
            <a class="social-youtube" href="https://www.youtube.com/channel/UCCFC7tdfd3MGjNE4BhMhbRQ?view_as=subscriber"
              target="_blank"><img src="assets/images/youtube.svg" alt="youtube"></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>